import React from 'react';

import SinglePage from './screens/SinglePage';

const App = () => {
  return <SinglePage />;
};
export default App;
